//ENUMS
export enum ModuleKeyEnum {
  MY_RESTAURANT = 'my-restaurant',
  MY_ACCOUNT = 'my-account',
  TIMECARDS = 'timecards',
  EMPLOYEE_AVAILABILITY = 'employee-availability',
  EMPLOYEE_TIME_OFF = 'employee-time-off',
  /** Web Dash Staff — Time off (module id 74) */
  TIME_OFF = 'time-off',
  EMPLOYEE_MANAGEMENT = 'employee-management',
  ROLES_PERMISSIONS = 'roles-permissions',
  ORDERS_PAYMENTS = 'orders-payments',
  HIRING = 'hiring',
  RESTAURANT_CONFIGURATIONS = 'restaurant-configurations',
  SHIFT_SCHEDULER = 'shift-scheduler',
  SHIFT_POOL = 'shift-pool',
  REPORTS = 'reports',
  CLOCK_IN = 'clock-in',
  TABLE_LAYOUT = 'table-layout',
  MENU = 'menu',
  PAYMENTS = 'payments',
  TICKET = 'ticket',
  HEADER = 'header',
  DASHBOARD = 'dashboard',
  CASHDRAWER = 'cashdrawer',
  LOGIN = 'login',
  RESTAURANT_LOCATION = 'restaurant-&-location',
  MENU_MANAGER = 'menu-manager',
  MARKETING = 'marketing',
  INVENTORY = 'inventory',
  ACCOUNTING = 'accounting',
  TASK_MANAGER = 'task-manager',
  AIO_CARE = 'aio-care',
  DOCVAULT = 'docvault',
  LOST_FOUND = 'lost-&-found',
  EMPLOYEE_PAYROLL = 'employee-payroll',
  ORDER_FORM = 'order-form',
  PAY_MANAGEMENT = 'pay-management',
  WEBSITE = 'website',
  INTEGRATIONS = 'integrations',
  ORDER_HUB = 'order-hub',
  INVENTORY_PREPARE_PREP_LIST = 'inventory-prepare-prep-list',
  INVENTORY_COOK_PREP_LIST = 'inventory-cook-prep-list',
  INVENTORY_WASTAGE_LOGS = 'inventory-wastage-logs',
  INVENTORY_VARIANCE = 'inventory-variance',
  INVENTORY_PLACED_ORDERS = 'inventory-placed-orders',
  EMPLOYEE_PAYOUT = 'employee-payout',
  NUGGET = 'nugget',
  TIPS_MANAGEMENT = 'tips-management',
  NOTIFICATIONS = 'notifications',
  SETTINGS = 'settings',
  PAYROLL = 'payroll',
}

export enum ModuleNameEnum {
  REPORTS = 'Reports',
  CATERING = 'Catering',
}
